module.exports = __webpack_public_path__ + "img/9302_fushia.009cd57d.jpg";